export default {
      id: "i-bpif-advantage-3-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-bpif-advantage-3",
      toString: function () {
        return this.url;
      }
    }